<template>
  <div id="filter-plot-type">
    <div>
      <vs-row vs-type="flex" class="mt-2">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="6"
        >
          <span class="aisea-text-16-400-white">全て</span>
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="6"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="allSwitch"/>
        </vs-col>
      </vs-row>

      <vs-divider class="mb-0" :color="AISEA_COLOR.GRAY"/>

      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-plot-img" :src="constructionIcon">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="5"
        >
          <span class="aisea-text-16-400-white ml-5">工事区域</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="6"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="constructionAreaSwitch"/>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-plot-img" :src="restrictionIcon">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="5"
        >
          <span class="aisea-text-16-400-white ml-5">航行制限区域</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="6"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="restrictionAreaSwitch"/>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-plot-img" :src="usefulIcon">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="5"
        >
          <span class="aisea-text-16-400-white ml-5">お役立ち</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="6"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="usefulAreaSwitch"/>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-plot-img" :src="attentionIcon">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="5"
        >
          <span class="aisea-text-16-400-white ml-5">注意</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="6"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="attentionAreaSwitch"/>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-plot-img" :src="emergencyIcon">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="5"
        >
          <span class="aisea-text-16-400-white ml-5">緊急</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="6"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="emergencyAreaSwitch"/>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import {PlotMixin, ColorMixin} from "@/mixins";
import LocalDbService from "@/services/localDbService";
import FireStoreService from "@/services/fireStoreService";
import {createNamespacedHelpers} from "vuex";
import _ from "lodash";

// Store
const {mapActions: mapActionsOfLiveMap} = createNamespacedHelpers("liveMap");

export default {
  name: "PlotDisplaySetting",
  mixins: [PlotMixin, ColorMixin],
  components: {},
  data() {
    return {
      isAllSwitchOnEvent: false,
      isAllFilterOffEvent: false,
      localFilterPlots: [],
      allSwitch: false,
      constructionAreaSwitch: false,
      restrictionAreaSwitch: false,
      usefulAreaSwitch: false,
      attentionAreaSwitch: false,
      emergencyAreaSwitch: false,
      constructionIcon: require("@/assets/images/plot/childCategory/UnderConstruction_w@96x-8.png"),
      restrictionIcon: require("@/assets/images/plot/childCategory/LimitedNavigationArea_w@96x-8.png"),
      usefulIcon: require("@/assets/images/plot/childCategory/LeisureSpot_w@96x-8.png"),
      attentionIcon: require("@/assets/images/plot/childCategory/Shallows_w@96x-8.png"),
      emergencyIcon: require("@/assets/images/plot/childCategory/AccidentReport_w@96x-8.png"),
    };
  },
  computed: {},
  watch: {
    localFilterPlots(val) {
      this._setFilterPlots(this, val)
    },
    async allSwitch(isOn) {
      if (isOn) {
        if (!this.isAllSwitchOnEvent) {
          await this.setAllFilter(true)
          let filterPlots = this.getPlotParentCategoryIds();
          this.localFilterPlots = filterPlots;
        } else {
          this.isAllSwitchOnEvent = false
        }
      } else {
        this.localFilterPlots = [];
        this.isAllFilterOffEvent = true
        await this.setAllFilter(false)
        this.isAllFilterOffEvent = false
      }
    },
    constructionAreaSwitch(isOn) {
      this.setFilterState(isOn, String(this.plotParentCategory.CONSTRUCTION))
    },
    restrictionAreaSwitch(isOn) {
      this.setFilterState(isOn, String(this.plotParentCategory.RESTRICTION))
    },
    usefulAreaSwitch(isOn) {
      this.setFilterState(isOn, String(this.plotParentCategory.USEFUL))
    },
    attentionAreaSwitch(isOn) {
      this.setFilterState(isOn, String(this.plotParentCategory.ATTENTION))
    },
    emergencyAreaSwitch(isOn) {
      this.setFilterState(isOn, String(this.plotParentCategory.EMERGENCY))
    },
  },
  methods: {
    ...mapActionsOfLiveMap(["setFilterPlots"]),
    _setFilterPlots: _.debounce((self, val) => {
      let filterPlots = _.cloneDeep(val)
      FireStoreService.saveFilterPlots(filterPlots)
      LocalDbService.saveFilterPlots(filterPlots);
      self.setFilterPlots(filterPlots);
    }, 1000),
    setFilterState(isOn, plotCategory) {
      if (this.isAllFilterOffEvent) return
      if (isOn) {
        this.localFilterPlots.push(plotCategory)
      } else {
        this.filterPlot(plotCategory)
      }
      if (this.localFilterPlots.length === 0) {
        this.allSwitch = false
      }
      if (this.getPlotParentCategoryIds().length === this.localFilterPlots.length) {
        this.allSwitch = true
      }
    },
    filterPlot(id) {
      this.localFilterPlots = this.localFilterPlots.filter(v => {
        return v !== id
      })
    },
    async setAllFilter(val) {
      this.constructionAreaSwitch = val;
      this.restrictionAreaSwitch = val;
      this.usefulAreaSwitch = val;
      this.attentionAreaSwitch = val;
      this.emergencyAreaSwitch = val;
    },
    async setFilterSwitch(filterPlots) {
      filterPlots.forEach(type => {
        switch (Number(type)) {
          case this.plotParentCategory.CONSTRUCTION :
            this.constructionAreaSwitch = true;
            break;
          case this.plotParentCategory.RESTRICTION :
            this.restrictionAreaSwitch = true;
            break;
          case this.plotParentCategory.USEFUL:
            this.usefulAreaSwitch = true;
            break;
          case this.plotParentCategory.ATTENTION:
            this.attentionAreaSwitch = true;
            break;
          case this.plotParentCategory.EMERGENCY:
            this.emergencyAreaSwitch = true;
            break;
        }
      })
    },
  },
  async created() {
    let filterPlots = await LocalDbService.getFilterPlots();
    if (filterPlots.length === 0) {
      this.allSwitch = false;
      await this.setAllFilter(false)
      this.localFilterPlots = filterPlots;
    } else {
      await this.setFilterSwitch(filterPlots)
      this.localFilterPlots = filterPlots;
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#filter-plot-type {
  background: $aisea-blue-gray;

  .filter-plot-img {
    height: 20px;
    width: 20px;
  }
}
</style>
